import React from 'react';

import { Radio as MuiRadio, RadioProps } from '@mui/material';
import { FieldRenderProps } from 'react-final-form';

import { ErrorMessage } from '../Error/Error';

import styles from './RadioInput.module.css';

export type Props = RadioProps &
  FieldRenderProps<string | number | boolean, HTMLInputElement>;

export const mapFieldRenderPropsToRadio = ({
  input: { checked, value, name, onChange, ...restInput },
  meta,
  ...rest
}: Props): RadioProps => ({
  name,
  inputProps: restInput,
  onChange,
  checked,
  value: value || '',
  ...rest,
});

export const Radio = (props: Props) => {
  const { meta, input } = props;
  return (
    <React.Fragment>
      <MuiRadio {...mapFieldRenderPropsToRadio(props)} />
      <ErrorMessage
        meta={meta}
        className={styles.errorMessage}
        name={input.name}
      />
    </React.Fragment>
  );
};
